import { render } from "./ribbons5.vue?vue&type=template&id=06f2dd0a"
import script from "./ribbons5.vue?vue&type=script&lang=js"
export * from "./ribbons5.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__